import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, observable } from 'rxjs';
import { Subject } from 'rxjs';
import { HttpService } from '../http/http.service';
import { Employee, EmployeeContract } from '../../interface';
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private http: HttpService) { }

  public getAll(): Promise<Employee[]> {
    return firstValueFrom(this.http.get('/Employees'));
  }
    public get(id:number): Promise<Employee> {
    return firstValueFrom(this.http.get('/Employees/'+id));
  }

  public create(data): Promise<Employee> {
    return firstValueFrom(this.http.post('/Employees', data));
  }
  
  public update(id:number,data): Promise<Employee> {
    return firstValueFrom(this.http.patch('/Employees/',id, data));
  }
  
  public delete(id:number): Promise<Employee> {
    return firstValueFrom(this.http.delete('/Employees/',id));
  }

}
